import React, { Component } from "react";
import {Link, withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import {FormattedMessage} from 'react-intl'

class Footer extends Component {

  handleClick(e) {
    eval('$("html, body").animate({scrollTop: "0px"}, 800)');
    //return true;
  }

  getRequestInfo() {
    if(this.props.WebPage.Request) {
      let req = this.props.WebPage.Request;
      return (<span>{req.IpAddress} - [{req.CountryCode}]</span>)
    } else {
      return null;
    }
  }


  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.reload(true) //Force cache update fuckers
  }

  render() {
    return (
      <footer className="footer">
        <div className="container flex flex--between flex--center">
          <div className="copyright">
            <FormattedMessage id={"page.footer.copyright"} /><br/>
          </div>

          <ul className="foot-menu flex flex--center">
            {this.props.WebPage.Menu.Footer.map((v,i) => {
              if(v.Page) {
                return <li key={"mnuli" + i} onClick={(e) => { this.handleClick(e) }}><Link className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description}>{v.Title}</Link></li>;
              } else {
                if(v.Settings) {
                  return <li key={"mnuli" + i} onClick={(e) => { this.handleClick(e) }}><a className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} href={v.Settings.Url} target="_blank" title={v.Description}>{v.Title}</a></li>;
                }
              }
              return null;
            })}
          </ul>
        </div>
      </footer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Footer);
